<template>
    <div class="full-screen bg-primary">
        <div class="container h-100 d-flex">
            <div class="col-12 col-md-6 offset-md-3 my-auto">
                <div class="d-flex w-100 h-100">
                    <form v-on:submit.prevent="register" class="bg-white w-100 midelivery-rounded px-200 py-150">
                        <h3 class="text-primary mb-100">Registro</h3>
                        <AppInput type="password" label="Contraseña" v-model="password"/>
                        <AppButton type="submit" class="ms-auto me-0 mt-100" variation="primary">Completar registro</AppButton>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppInput from '@/components/ui/AppInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import http from '@/http';
export default {
    components:{ AppInput, AppButton },
    data(){
        return {
            password:'',
        }
    },
    methods:{
        register(){
            http().post('/register', {
                'invite_token':this.$route.query.token,
                'password': this.password
            }).then(()=>{
                alert("Registro completado")
                this.$router.push('/')
            })
        }
    }
}
</script>